import { Injectable, Optional } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { YattaLinkBase } from '@platform-frontend/util';
import { MatomoTracker } from 'ngx-matomo-client';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class LinkRendererService {
  constructor(@Optional() private matomoTracker: MatomoTracker | null) {}

  renderLinkBase(link: YattaLinkBase, targetElement: HTMLAnchorElement): void {
    if ('class' in link) targetElement.setAttribute('class', link.class ?? '');
    if ('trackingEvent' in link && link.trackingEvent !== undefined && link.trackingEvent !== null) {
      const trackingEvent = link.trackingEvent;
      targetElement.addEventListener('click', () =>
        this.matomoTracker?.trackEvent(trackingEvent.category, trackingEvent.action, trackingEvent.name, trackingEvent.value)
      );
    }
  }
}
